export const indexFilterValuesSchema = {
    id: '/indexFilterValues',
    additionalProperties: {
        oneOf: [
            {$ref: '/numberSchema'},
            {$ref: '/addressSchema'},
            {$ref: '/orderHashSchema'},
        ],
    },
    type: 'object',
};



// WEBPACK FOOTER //
// ./~/0x.js/src/schemas/index_filter_values_schema.ts